import { render, staticRenderFns } from "./TweetAuthorMenu.vue?vue&type=template&id=da0c9a4e&"
import script from "./TweetAuthorMenu.vue?vue&type=script&lang=js&"
export * from "./TweetAuthorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports